<template>
  <div class="container">
    <div class="navi">
        <span class="icon-arrow-left" @click="goto('/pest-step3')"></span>
    </div>
    <div class="title">请选择房屋状况</div>
    <div class="main">



      <div class="item-title">
        房间数目
      </div>
      <div class="item">
        <div class="option-btn" :class="{ active: order.data.room_qty=='3'}" @click="orderUpdate('room_qty','3')">3房</div>
        <div class="option-btn" :class="{ active: order.data.room_qty=='4'}" @click="orderUpdate('room_qty','4')">4房</div>
        <div class="option-btn" :class="{ active: order.data.room_qty=='5'}" @click="orderUpdate('room_qty','5')">5房</div>
        <div class="option-btn" :class="{ active: order.data.room_qty=='6'}" @click="orderUpdate('room_qty','6')">6房以上</div>
      </div>

      <div class="item-title">
        房屋面积
      </div>
      <div class="item">
        <div class="option-btn" :class="{ active: order.data.extra_area=='0'}" @click="orderUpdate('extra_area','0')">600㎡以下</div>
        <div class="option-btn" :class="{ active: order.data.extra_area=='1'}" @click="orderUpdate('extra_area','1')">600～1000㎡</div>
        <div class="option-btn" :class="{ active: order.data.extra_area=='2'}" @click="orderUpdate('extra_area','2')">1000㎡以上</div>
      </div>

      <div class="item-title">
        是否包含 Granny Flat
      </div>
      <div class="item">
        <div class="option-btn" :class="{ active: order.data.extra_granny=='0'}" @click="orderUpdate('extra_granny','0');showGranny=false">不包含</div>
        <div class="option-btn" :class="{ active: showGranny}" @click="orderUpdate('extra_granny','10');showGranny=true;">包含</div>
      </div>

      <div class="item-title" v-show="showGranny">
        Granny Flat 房间数目
      </div>
      <div class="item"  v-show="showGranny">
        <div class="option-btn" :class="{ active: order.data.extra_granny=='1'}" @click="orderUpdate('extra_granny','1')">单间</div>
        <div class="option-btn" :class="{ active: order.data.extra_granny=='2'}" @click="orderUpdate('extra_granny','2')">多间</div>
      </div>
    </div>

    <div class="btn-box-fix">
      <div class="btn-container">

        <div class="btn" @click="checkSubmit()" :class="{ active: allFilled()}">下一步</div>
      </div>
    </div>
    <img :src="pixelURL('clean','fangjian')" class="hide">
  </div>
</template>

<script>
export default {
  name: 'pest-step4',
  data () {
    return {
      order:{},
      showGranny:false,
    }
  },
  methods: {
    allFilled(){
        if(this.order.data.room_qty && this.order.data.extra_area && this.order.data.extra_granny<3 && this.order.data.extra_granny!=''){
          return true;
        }
    },
    checkSubmit(){
        if(this.allFilled){
          this.orderUpdateAll('/pest-step4');
        }
        else{
          alert("请填写完所有项目")
        }
    },

  },
  components: {
  },
  created: function () {
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "pest"){
        this.order = localParsed;
      }
      else{
        this.$router.push('/');
      }
    }
    else{
      this.$router.push('/');
    }
    if(this.order.data.extra_granny==1 || this.order.data.extra_granny==2 ){
      this.showGranny=true;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.main{
  margin-top:14px;
  font-size:0.9em;
}

.multilayer{
  text-align:center;
  margin:20px 0;
  .option-btn{
    border:2px solid #fe9567;
    border-radius:4px;
    min-width:68px;
    padding:0 8px;
    height:34px;
    line-height:34px;
    color:#ff7444;
    display:inline-block;
    margin:0 4px;
    text-align:center;
    background:#fff;
  }

  .option-btn.active{
    border:2px solid #fe9567;
    border-radius:4px;
    width:68px;
    height:34px;
    line-height:34px;
    background-color:#fe9567;
    color:#fff;
    display:inline-block;
    margin:0 4px;
    -webkit-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
    -moz-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
    box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
  }
}

.item-title{
  margin:0 10vw 8px 10vw;
  display: flex;
  justify-content:left;
  align-items:center;
  font-size:1.1em;
  font-weight:bold;
  color:#5A5C68;
  img{
    margin-right:8px;
    width:32px;
  }
}
.item{
  margin:0 7vw 34px 7vw;
  display: flex;
  justify-content:left;
  align-items:center;
}


.option-btn{
  background:#eee;
  border-radius:4px;
  min-width:10vw;
  padding:2px 8px;
  height:28px;
  line-height:28px;
  color:#999;
  display:inline-block;
  margin:0 2vw;
  text-align:center;
  &.more{
    font-size:0.8em;
  }
}

.option-btn.active{
  background-color:#fe9567;
  color:#fff;
  -webkit-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
  -moz-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
  box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
}


</style>



// WEBPACK FOOTER //
// src/pages/pest/step3-house.vue